<template>
  <div>

    <!-- full screen navigation -->
    <div id="top-menu" :class="{introJsRemovePositionAbsolute: introActive}"
         uk-sticky="animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky uk-dark; cls-inactive:uk-navbar-transparent; top: 0">
      <nav class="uk-navbar-container uk-navbar-transparent" uk-navbar="mode: click">
        <div class="uk-navbar-left">
          <a href="/" class="uk-navbar-item uk-logo">
            <img class="logo-img" src="../../assets/images/logo/Icon-Blue-01.png"/></a>


          <!--  ONLY SHOW ON MEDIUM +  SCREENS -->
            <ul class="uk-navbar-nav uk-visible@m">
              <li id="dashboard-top-menu" v-show="isLoggedIn" class=""><a  @click="$router.push('/dashboard/')">Dashboard</a></li>
              <li v-show="isLoggedIn" v-if="isLoggedIn && seeArena" class=""><a  @click="$router.push('/arena/')">Arena</a></li>
              <li id="contact-top-menu" class="" ><a href="#" @click="$router.push('/help/')">Contact</a></li>
            </ul>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav">

            <!--  ONLY SHOW ON MEDIUM +  SCREENS -->
            <li class="uk-visible@m">
<!--            <li>-->
<!--              <navigate-up is-dashboard="true" size="45"/>-->
<!--            </li>-->
              <menu-search v-if="showSearch"></menu-search>
              <!--<div uk-dropdown="mode:click">-->
                <!--<ul class="uk-nav uk-navbar-dropdown-nav">-->
                  <!--<li v-for="r in search_results">-->
                    <!--<a :href="r.link">{{r.name}}</a>-->
                  <!--</li>-->
                <!--</ul>-->
              <!--</div>-->
            </li>
            <li v-show="isLoggedIn" class="uk-visible@m avatar-container">
              <Avatar size="45" badge="0"/>
              <div uk-dropdown="pos: bottom-center">
                    <ul class="uk-nav uk-dropdown-nav">
<!--                      <li><a href = "#">Profile</a></li>-->
                      <li><a href = "#" @click="logout">Logout</a></li>
                        <!--<li><a href = "#">Messages</a></li>-->
                    </ul>
                </div>
            </li>

            <li v-if="!isLoggedIn" class="uk-hidden@m">
                <a href="/help/">Contact</a>
            </li>

            <li class="uk-hidden@m">
              <div v-show="isLoggedIn" class="mobile-menu-icon" uk-toggle="target: #custom-side-menu">
                <span uk-icon="icon: menu; ratio: 2.4"></span>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>


    <!-- mobile navigation -->

    <div id="offcanvas-mobile-nav" class="uk-hidden@m" uk-offcanvas="overlay: true">
      <div class="uk-offcanvas-bar uk-flex uk-flex-column">

        <ul class="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
          <li class="uk-active"><a href="#">Active</a></li>
          <li class="uk-parent">
            <a href="#">Parent</a>
            <ul class="uk-nav-sub">
              <li><a href="#">Sub item</a></li>
              <li><a href="#">Sub item</a></li>
            </ul>
          </li>
          <li><a href="#">Item</a></li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>
	import menuSearch from './search.vue'
	import Avatar from './Avatar.vue'
    import navigateUp from './navigateUp.vue'
	import api from '../../store/apicall.js'

	export default {
		name: "topMenu",
		components: {
			menuSearch,
			Avatar,
          navigateUp
		},
		data: function () {
			return {
				search_results: [],
				search_input: "",
				search_result_cutoff: 5,
			}
		},
		methods: {
            processSearchResults: function (results) {
                console.log(results)
                if (results.length > this.search_result_cutoff) {
                    results = results.splice(0, this.search_result_cutoff)
                    results.push({'name': '...', 'link': '#'})
                }
                this.search_results = results
            },
			logout: function () {
				this.$store.dispatch('logout')
						.then(() => this.$router.push('/login'));

			}
		},
		computed: {
			isLoggedIn: function () {
				return this.$store.state.user.logged_in;
			},
			permissions: function () {
			    if (this.$store.state.user.data.permissions_list){
			        console.log(this.$store.state.user.data.permissions_list)
                    return this.$store.state.user.data.permissions_list
                } else {
			        return []
                }
			},
      seeArena: function() {
			    // return false
				return this.permissions.includes("see-arena")
      },
			introActive: function () {
				return this.$store.state.introStatus.status
			},

			showSearch: function () {
				return this.permissions.includes('see-all')
			},

		},
	}
</script>

<style lang="less">
  @import "../../../node_modules/uikit/src/less/uikit.less";
  @import "../../assets/less/theme.less";
  @import "../../assets/less/custom.less";

  .logo-img {
    max-height: 60px;
  }

  .mobile-menu-icon {
    opacity: .6;
    color: @secondary-2;

    &:hover {
      background-color: @secondary-2;
      color: white;
      border-radius: 8%;
    }
  }

  .avatar-container {
     margin-left: 15px;
  }

    .introJsRemovePositionAbsolute{
        position: relative !important;
    }

</style>
